import { Point, TooltipFormatterCallbackFunction } from 'highcharts';
import { translate } from '@jsverse/transloco';
import { ITimelineItemModel } from '../model/timeline-item.model';

export interface TimelineTooltipOptions {
    x: number;
    y: number;
    item: ITimelineItemModel;
    slip: number;
}

export class AssessmentTooltipFormatter {
    static readonly tooltipFormatter: TooltipFormatterCallbackFunction = function (this: Point): string {
        const options: TimelineTooltipOptions = this.options as TimelineTooltipOptions;
        const assessmentText = translate('TIMELINE.CHART.TOOLTIP.LABEL.ASSESSMENT');
        const dateText = translate('COMMON_UI.DATE');
        const originalText = translate('TIMELINE.CHART.TOOLTIP.LABEL.ORIGINAL');
        const slipText = translate('TIMELINE.CHART.TOOLTIP.LABEL.SLIP');
        const daySlipText =
            options.slip > 1
                ? translate('TIMELINE.CHART.TOOLTIP.LABEL.DAYS')
                : translate('TIMELINE.CHART.TOOLTIP.LABEL.DAY');

        return `
                    <span>${assessmentText}: ${options.item.name}</span><br/>
                    <span>${dateText}: ${options.item.date}</span><br/>
                        ${
                            options.slip > 0
                                ? `<span>` +
                                  originalText +
                                  `: ` +
                                  options.item.originalDate +
                                  `</span><br/>` +
                                  `<span>` +
                                  slipText +
                                  `: ` +
                                  String(`${options.slip} `) +
                                  `${daySlipText}` +
                                  `</span>`
                                : ``
                        }`;
    };
}
